import classNames from 'classnames';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'palette/Button';
import { Icon } from 'palette/Icon';
import { ModalContext } from 'palette/Modal';
import { toggleSearchSidebarVisibility } from '@common/GlobalSearch/actions';
import { DESKTOP_SEARCH_MODAL_ID } from '@common/GlobalSearch/constants';
import { toggleSearchBtnClassName } from '@common/GlobalSearch/containers/GlobalSearchHeaderContainer';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { GA_SEARCH_BURGER_LABEL, GA_SEARCH_CATEGORY, GA_SEARCH_OPEN_ACTION } from '@common/Tracking';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import './styles/BurgerNavSearch.scss';

export function BurgerNavSearch({
    onSearchInputClick,
    customClass
}) {
    const translate = useTranslation();
    const config = useConfig();
    const dispatch = useDispatch();
    const isSearchSidebarOpen = useSelector(state => state.globalSearch.sidebarVisibility);
    const isMobileMenuRefresh = config.isActiveFeature('PLT-34079_mobile_nav_refresh_2023');
    const { setActiveModalId } = useContext(ModalContext);

    const handleClick = () => {
        const searchToggleBtnElement = document.querySelector(`.${toggleSearchBtnClassName}`);

        if (searchToggleBtnElement) {
            onSearchInputClick();
            searchToggleBtnElement.click();
        } else {
            throw new Error('Search toggle was not found');
        }
    };

    const handleSearchButtonClick = () => {
        window.scrollTo(0, 0); //  Window scroll required to fix iOS safari mobile keyboard content shift bug.

        if (!isSearchSidebarOpen) {
            pushGAEventToDataLayer(GA_SEARCH_CATEGORY, GA_SEARCH_OPEN_ACTION, GA_SEARCH_BURGER_LABEL);
        }

        setActiveModalId(DESKTOP_SEARCH_MODAL_ID);
        dispatch(toggleSearchSidebarVisibility(true));
    };

    if (isMobileMenuRefresh) {
        return (
            <div>
                <Button
                    isTransparent
                    ariaLabel="Search"
                    iconName="palette_search"
                    size="large"
                    theme="secondary"
                    onClick={handleSearchButtonClick}
                />
            </div>
        );
    }

    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <div
            className={classNames('burger-nav-search', customClass)}
            onClick={handleClick}
        >
            <Icon
                className="burger-nav-search__icon"
                color="grey-600"
                name="palette_search"
            />
            {translate('header.search.input.default')}
        </div>
    );
}
